// export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000': ''

export const BASE_URL = ''
export const PRODUCTS_URL = '/api/products'
export const USERS_URL = '/api/users'
export const ORDERS_URL = '/api/orders'
export const UPLOAD_URL = '/api/upload'


export const categoriesDB = 
{
    'By Profession': {
        'speech therapy': [
            "Phonology",
            "Phonetics",
            "Semantic",
            "Morphology",
            "Syntax",
            "Pragmatic",
            "Orofacial",
            "Voice",
            "Reading",
            "Writing",
            "Math" 
        ],
        'psychology': [
            "Behaviour",
            "Attention",
            "Mental Health",
            "Toxicology",
            "Cognition",
            "Development",
            "Social",
            "Personality",
        ],
        'physiotherapy': [
            "Sports",
            "Paediatric",
            "Geriatry",
            "Muscle",
            "Bones",
            "Post-Operative",
            "Pre-Operative",
            "Miscellaneous",
        ],
        'occupational therapy': [
            "Tracing",
            "Orientation",
            "Routines",
            "Vocational",
            "Disorders",
            "Injuries",
            "Sensory",
            "Neurology",
        ],
        'psychomotricity': [
            "Gross Motor Skills",
            "Fine Motor Skills",
            "Spatial Organization",
            "Temporal Organization",
            "Body Perception",
            "Emotional Regulation",
            "Graphomotricity",
            "Auto-regulation",
        ]
    },
     'By Resource Type': {
    'Patient Tasks': [
      "Worksheets",
      "Flash Cards",
      "Interactive Games",
      "Role Playing",
      "Story-based Tasks"
    ],
    'Therapist Materials': [
      "Assessments",
      "Lesson Plans",
      "Manuals",
      "Guides",
      "Progress Trackers"
    ],
    'Multimedia Resources': [
      "Videos",
      "Audio Prompts",
      "Printable Boards",
      "Posters",
      "Slideshows"
    ],
    'Administrative Tools': [
      "Intake Forms",
      "Consent Forms",
      "Session Notes",
      "Scheduling Aids",
      "Reports Templates"
    ]
  },
  'By Purpose or Objective': {
    'Skill Development': [
      "Communication",
      "Mobility",
      "Emotional Regulation",
      "Cognitive Functioning",
      "Sensory Integration"
    ],
    'Assessment & Diagnosis': [
      "Initial Evaluations",
      "Screening Tools",
      "Standardized Tests",
      "Observation Checklists",
      "Functional Assessments"
    ],
    'Care Planning': [
      "Treatment Plans",
      "Goal Setting Templates",
      "Session Planning",
      "Progress Monitoring"
    ],
    'Family & Caregiver Support': [
      "Parent Guides",
      "Home Activities",
      "Instructions Sheets",
      "Communication Logs"
    ]
  },

  'By Setting or Environment': {
    'Clinic-Based': [
      "Diagnostic Kits",
      "Visual Aids",
      "Clinic Activities",
      "Evaluation Tools"
    ],
    'School-Based': [
      "Classroom Adaptations",
      "IEP Support Materials",
      "Behavior Charts",
      "Collaborative Activities"
    ],
    'Home-Based': [
      "Take-Home Tasks",
      "Parent Training",
      "Routine Charts",
      "Everyday Practice Sheets"
    ],
    'Teletherapy': [
      "Digital Worksheets",
      "Screen-Share Games",
      "Virtual Engagement Tools",
      "Remote Assessment Forms"
    ]
  },

  'By Age Group or Population': {
    'Infants & Toddlers': [
      "Early Stimulation",
      "Parent-Led Activities",
      "Developmental Milestones",
      "Feeding Tools"
    ],
    'Children': [
      "Play-Based Therapy",
      "Literacy & Numeracy",
      "Behavior Support",
      "Group Activities"
    ],
    'Teens': [
      "Executive Functioning",
      "Social Skills",
      "Mental Health Check-Ins",
      "Self-Reflection Sheets"
    ],
    'Adults': [
      "Rehabilitation Aids",
      "Memory & Orientation",
      "Work Readiness",
      "Life Skills Training"
    ],
    'Elderly': [
      "Fall Prevention",
      "Cognitive Maintenance",
      "Fine Motor Training",
      "Daily Living Support"
    ]
  },
}

export const availableLanguages = [
  "English (US)",
  "English (UK",
  "French",
  "Spanish",
  "German",
  "Arabic",
  "Italian",
  "Dutch",
  "Dariya (Morocco)",
];

export const languageFlags = {
  'English (US)': 'https://flagcdn.com/us.svg',
  'English (UK)': 'https://flagcdn.com/uk.svg',
  'French': 'https://flagcdn.com/fr.svg',
  'Spanish': 'https://flagcdn.com/es.svg',
  'German': 'https://flagcdn.com/de.svg',
  'Arabic': 'https://flagcdn.com/sa.svg',
  'Italian': 'https://flagcdn.com/it.svg',
  'Dutch': 'https://flagcdn.com/nl.svg',
  'Dariya (Morocco)': 'https://flagcdn.com/ma.svg',
};


export const searchKeywords = 
{
    'By Profession': {
        'speech therapy': [
            "Phonology",
            "Phonetics",
            "Semantic",
            "Morphology",
            "Syntax",
            "Pragmatic",
            "Orofacial",
            "Voice",
            "Reading",
            "Writing",
            "Math" 
        ],
        'psychology': [
            "Behaviour",
            "Attention",
            "Mental Health",
            "Toxicology",
            "Cognition",
            "Development",
            "Social",
            "Personality",
        ],
        'physiotherapy': [
            "Sports",
            "Paediatric",
            "Geriatry",
            "Muscle",
            "Bones",
            "Post-Operative",
            "Pre-Operative",
            "Miscellaneous",
        ],
        'occupational therapy': [
            "Tracing",
            "Orientation",
            "Routines",
            "Vocational",
            "Disorders",
            "Injuries",
            "Sensory",
            "Neurology",
        ],
        'psychomotricity': [
            "Gross Motor Skills",
            "Fine Motor Skills",
            "Spatial Organization",
            "Temporal Organization",
            "Body Perception",
            "Emotional Regulation",
            "Graphomotricity",
            "Auto-regulation",
        ]
    },
     'By Resource Type': {
    'Patient Tasks': [
      "Worksheets",
      "Flash Cards",
      "Interactive Games",
      "Role Playing",
      "Story-based Tasks"
    ],
    'Therapist Materials': [
      "Assessments",
      "Lesson Plans",
      "Manuals",
      "Guides",
      "Progress Trackers"
    ],
    'Multimedia Resources': [
      "Videos",
      "Audio Prompts",
      "Printable Boards",
      "Posters",
      "Slideshows"
    ],
    'Administrative Tools': [
      "Intake Forms",
      "Consent Forms",
      "Session Notes",
      "Scheduling Aids",
      "Reports Templates"
    ]
  },
  'By Purpose or Objective': {
    'Skill Development': [
      "Communication",
      "Mobility",
      "Emotional Regulation",
      "Cognitive Functioning",
      "Sensory Integration"
    ],
    'Assessment & Diagnosis': [
      "Initial Evaluations",
      "Screening Tools",
      "Standardized Tests",
      "Observation Checklists",
      "Functional Assessments"
    ],
    'Care Planning': [
      "Treatment Plans",
      "Goal Setting Templates",
      "Session Planning",
      "Progress Monitoring"
    ],
    'Family & Caregiver Support': [
      "Parent Guides",
      "Home Activities",
      "Instructions Sheets",
      "Communication Logs"
    ]
  },

  'By Setting or Environment': {
    'Clinic-Based': [
      "Diagnostic Kits",
      "Visual Aids",
      "Clinic Activities",
      "Evaluation Tools"
    ],
    'School-Based': [
      "Classroom Adaptations",
      "IEP Support Materials",
      "Behavior Charts",
      "Collaborative Activities"
    ],
    'Home-Based': [
      "Take-Home Tasks",
      "Parent Training",
      "Routine Charts",
      "Everyday Practice Sheets"
    ],
    'Teletherapy': [
      "Digital Worksheets",
      "Screen-Share Games",
      "Virtual Engagement Tools",
      "Remote Assessment Forms"
    ]
  },

  'By Age Group or Population': {
    'Infants & Toddlers': [
      "Early Stimulation",
      "Parent-Led Activities",
      "Developmental Milestones",
      "Feeding Tools"
    ],
    'Children': [
      "Play-Based Therapy",
      "Literacy & Numeracy",
      "Behavior Support",
      "Group Activities"
    ],
    'Teens': [
      "Executive Functioning",
      "Social Skills",
      "Mental Health Check-Ins",
      "Self-Reflection Sheets"
    ],
    'Adults': [
      "Rehabilitation Aids",
      "Memory & Orientation",
      "Work Readiness",
      "Life Skills Training"
    ],
    'Elderly': [
      "Fall Prevention",
      "Cognitive Maintenance",
      "Fine Motor Training",
      "Daily Living Support"
    ]
  },
  'Search Keywords': {
    'Spanish': [
      "Tarjetas",
      "Pegatinas",
      "Actividades",
      "Marioneta",
      "Marionetas",
      "Cuaderno",
      "Vocabulario",
      "Sintaxis",
      "Fotos",
      "Cuento",
      "Cuentos",
    ],
    'French': [
      "Histoire",
      "Histoires",
      "Conte",
      "Collage",
      "Syntaxe",
      "Photos",
      "Vocabulaire",
      "Activités",
      "Cartes",
    ],
  },
}


// src/data/banners.js
export const banners = [
  {
    image: "/banners/bannerAdSpace.jpg",
    buttonName: "Explore More",
    buttonLink: "/shop",
  },
  {
    image: "/banners/bannerAdSpace2.jpg",
    buttonName: "Become a Creator",
    buttonLink: "/search",
  },
  {
    image: "/banners/bannerAdSpace3.jpg",
    buttonName: "Check our Sales",
    buttonLink: "/search/therapy",
  },
  {
    image: "/banners/bannerAdSpace4.jpg",
    buttonName: "Learn More",
    buttonLink: "/search/therapy",
  },
];




export const countryCityData = {
  // 🟠 MENA
  "Morocco": ["Casablanca", "Rabat", "Marrakesh", "Fes"],
  "Algeria": ["Algiers", "Oran", "Constantine", "Annaba"],
  "Tunisia": ["Tunis", "Sfax", "Sousse"],
  "Egypt": ["Cairo", "Alexandria", "Giza", "Luxor"],
  "Saudi Arabia": ["Riyadh", "Jeddah", "Mecca", "Medina"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi", "Sharjah"],
  "Jordan": ["Amman", "Zarqa", "Irbid"],
  "Lebanon": ["Beirut", "Tripoli", "Sidon"],
  "Qatar": ["Doha", "Al Rayyan"],
  "Kuwait": ["Kuwait City", "Hawalli"],

  // 🔵 Europe
  "France": ["Paris", "Lyon", "Marseille", "Toulouse"],
  "Germany": ["Berlin", "Munich", "Hamburg", "Frankfurt"],
  "Spain": ["Madrid", "Barcelona", "Valencia", "Seville"],
  "Italy": ["Rome", "Milan", "Naples", "Florence"],
  "United Kingdom": ["London", "Manchester", "Birmingham", "Glasgow"],
  "Netherlands": ["Amsterdam", "Rotterdam", "The Hague"],
  "Sweden": ["Stockholm", "Gothenburg", "Malmö"],
  "Greece": ["Athens", "Thessaloniki", "Patras"],
  "Poland": ["Warsaw", "Kraków", "Gdańsk"],

  // 🟦 North America
  "United States": ["New York", "Los Angeles", "Chicago", "Houston", "Miami"],
  "Canada": ["Toronto", "Vancouver", "Montreal", "Calgary"],
  "Mexico": ["Mexico City", "Guadalajara", "Monterrey", "Puebla"]
}
